export default "__VITE_ASSET__BPcLfB8s__"